export default __webpack_public_path__ + "static/media/takboxRosaGallery.1aaab5bf.jpg";